import {css, keyframes} from '@emotion/css';
import {colours, spacing} from '@fo/shared/styles/variables';
import {Breakpoints, mq} from '@fo/shared/styles/mixins';

export default {
  baseModal: css`
    label: baseModal;
  `,
  wrapper: css`
    label: baseModal__wrapper;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999; // set high to ensure modal sits on top of everything
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100vw; /* stylelint-disable-line */
    height: 100vh; /* stylelint-disable-line */
    padding: ${spacing.XXS};
  `,
  background: css`
    label: baseModal__background;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.25);
    backdrop-filter: blur(8px);
    animation: ${keyframes`
      0% {
        opacity: 0;
      }

      100% {
        opacity: 1;
      }
  `} 200ms ease-out;
  `,

  container: css`
    label: baseModal__container;
    z-index: 1;
    overflow: auto;
    padding: ${spacing.XS};
    background: ${colours.general.WHITE};
    box-shadow: 0px 4px 25px rgba(0, 0, 0, 0.25);
    border-radius: 1rem;
    width: calc(100% - ${spacing.S});
    max-width: 
    animation: ${keyframes`
      0% {
        opacity: 0;
        transform: scale(0.75, 0.75);
      }

      100% {
        opacity: 1;
        transform: scale(1, 1);
      }
  `} 300ms cubic-bezier(0, 0.5, 0.5, 1);

    ${mq(Breakpoints.TABLET)} {
      padding: ${spacing.S};
      max-width: 73rem;
    }
  `,
  topSection: css`
    label: baseModal__topSection;
    display: flex;
    justify-content: flex-end;
  `,
  closeButton: css`
    label: baseModal__closeButton;
    display: flex;
    width: auto;
    min-height: auto;
    text-align: right;
  `,
  content: css`
    label: baseModal__content;
    margin: 0 auto;
    text-align: center;
  `,
};
